<div class="tt-filter-multi-select relative min-w-0" [class.opacity-60]="disabled">
  <button
    #triggerBtn
    type="button"
    [class]="icon ? 'tt-filter-icon-btn' : 'tt-filter-control text-left flex items-center justify-between gap-2 w-full'"
    [class.tt-filter-icon-btn--active]="!!icon && (showIconBadge || panelOpen)"
    [ngClass]="icon ? null : controlClass"
    [disabled]="disabled"
    [attr.aria-label]="icon ? iconAriaLabel : null"
    [attr.title]="icon ? iconTitle : null"
    [attr.aria-expanded]="panelOpen"
    [attr.aria-haspopup]="'listbox'"
    (mousedown)="$event.stopPropagation()"
    (click)="togglePanel()"
  >
    <ng-container *ngIf="icon; else textTrigger">
      <app-vocab-icon [name]="icon"></app-vocab-icon>
      <span *ngIf="showIconBadge" class="tt-filter-icon-btn__badge" aria-hidden="true"></span>
    </ng-container>
    <ng-template #textTrigger>
      <span class="min-w-0 flex-1 text-left">
        <span
          class="block truncate"
          [class.text-neutral-500]="!hasSelection"
          [class.dark:text-neutral-400]="!hasSelection"
        >{{ summaryText }}</span>
        <span
          *ngIf="summarySubtitle"
          class="block text-xs text-neutral-500 dark:text-neutral-400 mt-0.5 truncate"
        >{{ summarySubtitle }}</span>
      </span>
      <svg class="w-4 h-4 shrink-0 text-neutral-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
      </svg>
    </ng-template>
  </button>

  <div
    #panelEl
    *ngIf="panelOpen"
    class="tt-filter-multi-select__panel fixed w-max max-w-[24rem] border overflow-hidden"
    [ngStyle]="panelStyle"
    (mousedown)="onPanelPointerDown($event)"
  >
    <div *ngIf="icon && (label || emptyLabel)" class="tt-filter-multi-select__panel-title">{{ label || emptyLabel }}</div>
    <div *ngIf="showOptionSearch" class="tt-filter-multi-select__search">
      <input
        #optionSearchInput
        type="search"
        class="input tt-filter-control"
        [placeholder]="optionSearchPlaceholder"
        autocomplete="off"
        aria-label="Hledat v možnostech"
        [(ngModel)]="optionQuery"
        [ngModelOptions]="{standalone: true}"
        (keydown)="onSearchKeydown($event)"
      />
    </div>
    <div
      class="overflow-y-auto py-1"
      [style.max-height]="panelMaxHeight"
      role="listbox"
      [attr.aria-label]="label || emptyLabel || 'Výběr filtru'"
    >
      <ng-container *ngFor="let opt of visibleOptions; let i = index; trackBy: trackByValue">
        <div
          *ngIf="shouldShowGroupHeader(opt, i)"
          class="tt-filter-multi-select__group"
          role="presentation"
        >
          {{ opt.group }}
        </div>
        <label
          class="tt-filter-multi-select__option flex items-start gap-2 px-3 py-2 text-sm cursor-pointer"
          (mousedown)="onOptionMouseDown(opt.value, $event)"
        >
          <input
            type="checkbox"
            class="mt-0.5 h-4 w-4 rounded border-neutral-300 text-primary-600 focus:ring-primary-500"
            [checked]="isChecked(opt.value)"
            (change)="onCheckboxChange(opt.value, $any($event.target).checked)"
          />
          <span class="min-w-0">
            <span class="break-words" [ngClass]="opt.labelClass">{{ opt.label }}</span>
            <span
              *ngIf="opt.subtitle"
              class="block text-xs text-neutral-500 dark:text-neutral-400 mt-0.5 break-words"
            >{{ opt.subtitle }}</span>
          </span>
        </label>
      </ng-container>
      <p *ngIf="visibleOptions.length === 0" class="px-3 py-2 text-sm text-neutral-500 dark:text-neutral-400">{{ optionsEmptyMessage }}</p>
    </div>
    <div
      *ngIf="showFooter"
      class="tt-filter-multi-select__footer border-t px-3 py-2 flex flex-wrap items-center gap-x-3 gap-y-1"
    >
      <ng-container *ngIf="showBulkToggleFooter">
        <button
          *ngIf="!bulkToggleAllSelected"
          type="button"
          class="text-xs text-primary-600 dark:text-primary-400 hover:underline"
          (click)="bulkToggleAll()"
        >
          {{ bulkToggleAllLabel }}
        </button>
        <button
          *ngIf="bulkToggleAnySelected"
          type="button"
          class="text-xs text-primary-600 dark:text-primary-400 hover:underline"
          (click)="bulkToggleNone()"
        >
          {{ bulkToggleNoneLabel }}
        </button>
      </ng-container>
      <button
        *ngIf="showClearFooter"
        type="button"
        class="text-xs text-primary-600 dark:text-primary-400 hover:underline"
        (click)="clearSelection()"
      >
        Zrušit výběr
      </button>
    </div>
  </div>
</div>
